import type { Preset } from './Tab.types'

// TODO: Ask backend if this can be avoiding by supporting new preset values
export function sanitizedPreset(preset: Preset) {
  if (preset === 'all') {
    return {}
  }

  if (preset === 'needing-response') {
    return { preset: 'needing_response' }
  }

  return { preset: preset.toString() }
}
